import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-inactive-category',
  templateUrl: './bar-chart-inactive-category.component.html',
  styleUrls: ['./bar-chart-inactive-category.component.css']
})
export class BarChartInactiveCategoryComponent implements OnInit {

      // per inizializzazione
      getAuthState: Observable<any>;
      getDoctorState: Observable<any>;
      isAuthenticated: boolean;
      user = null;
      errorMessage = null;
      subscription1: Subscription;
      subscription2: Subscription;
      subscription3: Subscription;
      subscription5: Subscription;
      title = "Categoria";
      destination = 'inactive';
      // elementi che servono per il bar-chart
      canvas: any;
      ctx: any;
      myChartInactivePatients: Chart;
      // ******************************************************************************************************************
      
      // ******************************************************************************************************************
      // seguenti righe: inizializzazione dei pazienti 
      // ******************************************************************************************************************
      inactiveGlobalStandard = 0;
      inactiveGlobalTelemedicine = 0;
      activeGlobalStandard = 0;
      activeGlobalTelemedicine = 0;
      standardGlobalPatients = 0;
      telemedicineGlobalPatients = 0;
      inactiveGlobalPatientsArray = [];
      activeGlobalPatientsArray = [];
      inactivePatientsGlobal = [];
      // ******************************************************************************************************************
      // bar chart dei pazienti 
      // ******************************************************************************************************************
      public barChartLabelsGlobalInactive = ['TELEMEDICINA', 'STANDARD'];
      public barChartTypeGlobalInactive = 'horizontalBar';
      public barChartLegendGlobalInactive = true;
      public barChartDataGlobalInactive = [
        {
          data: this.activeGlobalPatientsArray, label: 'Attivi', backgroundColor: ['teal', 'teal'],
          hoverBackgroundColor: ['#066', '#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
        },
        {
          data: this.inactiveGlobalPatientsArray, label: 'Inattivi', backgroundColor: ['orangered','orangered'],
          hoverBackgroundColor: ['#cc3700', '#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
        }];
      // paginator Inactive
      public pageSizeInactive = 5;
      public currentPageInactive = 0;
      public tasksInactive: any[];
      public totalSizeInactive = 0;
      // selezione Inactive Patients Global
      selectedInactive = false;
      patientInactiveMail: string[] = [];
      checkedInactive = false;
      // hover variables of Inactive
      isActiveInactiveHovered = false;
      @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
        if (paginator) {
          paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
          paginator._intl.previousPageLabel = 'Pagina precedente';
          paginator._intl.nextPageLabel = 'Pagina successiva';
        }
      }
      // constructor
      constructor(private store: Store<AppState>,
                  private doctorService: DoctorService,
                  private snackBar: MatSnackBar) {
        this.getAuthState = this.store.select(selectAuthState);
        this.getDoctorState = this.store.select(selectDoctorState);
      }
      // ******************************************************************************************************************
      // metodo all'inizio
      ngOnInit(): void {
        this.subscription5 = this.getAuthState.subscribe((state) => {
          this.isAuthenticated = state.isAuthenticated;
          this.user = JSON.parse(localStorage.getItem('user'));
          this.errorMessage = state.errorMessage;
          this.retrieveGlobalInactiveTelemedicine();
        });
      }
      ngOnDestroy(): void {
        this.subscription1.unsubscribe();
        this.subscription2.unsubscribe();
        this.subscription3.unsubscribe();
        this.subscription5.unsubscribe();
      }
      // ******************************************************************************************************************
      // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
      // e in standard e poi tutti
      // i pazienti in ogni categoria per poter calcolare gli attivi
      // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
      retrieveGlobalInactiveTelemedicine() {
        this.subscription1 = this.doctorService.getInactiveTelemedicineNumber().subscribe(npatients => {
          this.inactiveGlobalTelemedicine = parseInt(npatients.toString());
          this.inactiveGlobalPatientsArray.push(this.inactiveGlobalTelemedicine); // riempio vettore del bar-chart con telemedicina
          this.retrieveGlobalInactiveStandard();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
      retrieveGlobalInactiveStandard() {
        this.subscription2 = this.doctorService.getInactiveStandardNumber().subscribe(npatients => {
          this.inactiveGlobalStandard = parseInt(npatients.toString());
          this.inactiveGlobalPatientsArray.push(this.inactiveGlobalStandard); // riempio il vettore del bar chart con standard
          this.retrieveGlobalTelemedicineStandardNumber();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
    
      retrieveGlobalTelemedicineStandardNumber() {
        this.subscription3 = this.doctorService.getGlobalStandardTeleMedicineNumber().subscribe(num => {
          this.standardGlobalPatients = num[0];
          this.telemedicineGlobalPatients = num[1];
          this.activeGlobalTelemedicine = this.telemedicineGlobalPatients - this.inactiveGlobalTelemedicine;
          this.activeGlobalPatientsArray.push(this.activeGlobalTelemedicine); // riempio il vettore del bar chart con telemedicina
          this.activeGlobalStandard = this.standardGlobalPatients - this.inactiveGlobalStandard;
          this.activeGlobalPatientsArray.push(this.activeGlobalStandard); // riempio il vettore del bar chart con standard
          this.canvasSetting();
        }, error => {
          if (error.status === 500) {
            localStorage.setItem('expirationTime', '0');
            console.log('SESSIONE SCADUTA');
            location.reload();
          }
        });
      }
     
      canvasSetting() {
          this.canvas = document.getElementById('myChartInactiveTelemedicineStandard') as HTMLCanvasElement;
          this.ctx = this.canvas.getContext('2d');
          this.myChartInactivePatients = new Chart(this.ctx, {
            type: this.barChartTypeGlobalInactive,
            data: {
              labels: this.barChartLabelsGlobalInactive,
              datasets: this.barChartDataGlobalInactive,
            },
            options: {
              maintainAspectRatio: true,
              responsive: true,
              scales: {
                xAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
                yAxes: [{
                  display: true,
                  stacked: false,
                  ticks: {
                    fontSize: 12,
                    fontStyle: 'bold',
                    fontFamily: 'Helvetica',
                    fontColor: '#006192'
                  }
                }],
              },
              legend: {
                display: true,
                position: 'top',
                labels: {
                  usePointStyle: true,
                  fontColor: '#006192',
                  fontSize: 18,
                  fontFamily: 'Helvetica',
                }
              },
              tooltips: {
                // content: '{pathology}: {number}',
                backgroundColor: '#1c1c1c',
                bodyFontSize: 18,
                titleFontSize: 18,
                cornerRadius: 5,
                caretPadding: 10
              },
              title: {
                display: true,
                text: "N° di utenti attivi/inattivi",
                fontColor: '#006192',
                fontSize: 20,
                fontFamily: 'Helvetica',
              },
              hover: {
                mode: 'nearest',
                intersect: true
              }
            }
          });
          } // dopo aver ottenuto tutti i dati creo il bar chart
        }